import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useNavigate,useParams } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { setSwitchRegion  } from "../../redux/authSlice";
import ButtonContained from '../button';
import Input from '../input';
import TextArea from '../textarea';
import { EditCustomerInfoSchea } from '../../validation/ValidationSchema';
import { api } from "../../api";
import { toast } from "react-toastify";


const EditCustomerInfo = () => {
    const token = useSelector((state) => state.auth.token);
    const navigate = useNavigate();
     // eslint-disable-next-line
    const [ apiAccess, setApiAccess ] = useState(false)
    
    const [ data, setData ] = useState({})

    const dispatch = useDispatch();


    const { id } = useParams()
   // eslint-disable-next-line
    const [ isLoading, setIsLoading ] = useState(false)

    useEffect(() => {
        dispatch(setSwitchRegion(false));
    
        return () => {
            dispatch(setSwitchRegion(true)); // reset when unmounting
        };
        }, [dispatch]);
 
    useEffect(() => {
        api.customerInfo.getCustomerInfoById({ id },token)
            .then(res => setData(res.data))
            .catch(err => console.log(err, ' err'))

    //     const staticdata ={
    //     "id": 63,
    //     "name": "test002",
    //     "phone": "1234567890",
    //     "email": "test002@dispostable.com",
    //     "address": "Hello World, 123 Street, Bangalore, 560043",
    //     "uniqueCode": "UU3HEE",
    //     "status": true,
    //     "createdAt": "2021-02-22T18:02:02.021Z",
    //     "updatedAt": "2021-03-02T07:40:29.765Z"
    //   }
    //   setData(staticdata);

      }, [id,token]);
 
    return (
        <Formik
            enableReinitialize
            validationSchema={ EditCustomerInfoSchea }
            initialValues={{
                name: data.name || "",
                email: data.email || '',
                phone: data.phone || "",
                address: data.address || ""
            }}
            onSubmit={(values, { resetForm }) => {
                const formBody = {
                    name: values.name,
                    email: values.email,
                    phone: values.phone,
                    address: values.address,
                    id // uncomment on add
                };
                // api.customerInfo.addCustomerInfo(formBody)
                //     .then(res => console.log(res, ' ress'))
                //     .catch(err => console.log(err, ' errr'))
                api.customerInfo.updateCustomerInfo(formBody,token)
                .then(res => {
                    if (res.code !== 200) {
                        toast.error("Something went wrong");
                    }
                    else {
                        toast.success(res.message);
            
                        navigate('/customer-info')
                    }
                }).catch(err => {
                    console.log(err, ' err')
                })
            }
        }
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue

            }) => {
                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head">
                                        <h1 className="sec-header">EDIT CUSTOMER INFO</h1>
                                    </div>
                                    <div className="card card-table">
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                                <Form onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                        

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="name"
                                                                name="name"
                                                                placeholder="Customer Name"
                                                                type="text"
                                                                label="Customer Name"
                                                                value={values.name}
                                                                onChange={handleChange}
                                                                error={touched.name && errors.name}
                                                                errorText={errors.name}
                                                                disabled={isSubmitting}
                                                            />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="email"
                                                                name="email"
                                                                placeholder="Email"
                                                                type="text"
                                                                label="Email"
                                                                value={values.email}
                                                                onChange={handleChange}
                                                                error={touched.email && errors.email}
                                                                errorText={errors.email}
                                                                disabled={isSubmitting}
                                                                />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="phone"
                                                                name="phone"
                                                                placeholder="Phone"
                                                                type="text"
                                                                label="Phone"
                                                                value={values.phone}
                                                                onChange={handleChange}
                                                                error={touched.phone && errors.phone}
                                                                errorText={errors.phone}
                                                                disabled={isSubmitting}
                                                                />
                                                        </div>

                                                    </div>
                                                        
                                                    <div className="form-row">

                                                    <div className="form-group col-md-4">
                                                            <TextArea
                                                                id="address"
                                                                name="address"
                                                                placeholder="Address"
                                                                type="text"
                                                                label="Address"
                                                                value={values.address}
                                                                onChange={handleChange}
                                                                error={touched.address && errors.address}
                                                                errorText={errors.address}
                                                                disabled={isSubmitting}
                                                                />
                                                        </div>

                                                    </div>
                                                    <br />


                                                    <ButtonContained buttonName="Save" disabled={isSubmitting} />

                                                </Form>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Formik >
    );

}

export default EditCustomerInfo;